import { jsx } from 'react/jsx-runtime';
import styles from './Icon.module.css.js';
import { iconMap } from './iconMap.js';

function Icon({ name, size = "base" }) {
    const IconElement = iconMap[name];
    return jsx(IconElement, { className: styles[size], title: `${name} icon` });
}

export { Icon };
//# sourceMappingURL=Icon.js.map
